import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';
import { UserAccess } from 'webapp/enums/enums';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';
import UserAccessPermissionsComponent from 'webapp/components/user/access-permissions';

import Goal from 'webapp/models-custom/goal';

export default class PopupAccessPermissionsModalComponent extends PopupInnerModalComponent<PopupData.Common.AccessPermissions> {
	@service('request') declare requestService: Service.Request;
	@service('infolayer') declare infolayerService: Service.Infolayer;

	boardAccess: UserAccess | null = null;
	usersWithPermissions: LabelValuePairNumeric[] = [];

	get model() {
		return this.popupData.model;
	}

	get name() {
		return this.model instanceof Goal ? this.model.title : this.model.name;
	}

	get title() {
		let title = 'User access';
		if (this.name) {
			title += ` for ${this.name}`;
		}
		return title;
	}

	@action
	changeAccessAndPermissions(access: UserAccess, users: LabelValuePairNumeric[]): void {
		this.boardAccess = access;
		this.usersWithPermissions = access === UserAccess.RESTRICTED ? users : [];
	}

	@action
	save() {
		const model = this.model;
		const newAccess = this.boardAccess as number;
		const selectedUserIds = this.usersWithPermissions.map((u) => u.value);

		if (this.popupData.saveFn) {
			this.popupData.saveFn(newAccess, selectedUserIds);
			this.close();
			return;
		}

		const isAccessChangeSuccessful = model.changeAccess(newAccess, selectedUserIds);

		this.submitInProgress = true;
		model
			.save()
			.then(() => {
				if (isAccessChangeSuccessful) {
					this.infolayerService.ok('Dashboard user access has been changed.');
				}
				this.close();
			})
			.finally(() => {
				this.submitInProgress = false;
			})
			.catch(this.requestService.showAllValidationErrors.bind(this.requestService));
	}
	<template>
		<div class="context-ct">
			<div class="title">
				<CommonUiIconComponent @name="UserAccess" @size="lg" />
				{{this.title}}
			</div>
			<div class="content">
				<UserAccessPermissionsComponent
					@model={{this.model}}
					@onChange={{this.changeAccessAndPermissions}}
					@onContentChange={{this.scheduleReposition}}
				/>
				<div class="controls2">
					<div class="controls2__right">
						<SubmitButtonComponent
							@text="Cancel"
							@theme="grey-empty"
							@noDelay={{true}}
							@onTrigger={{this.close}}
						/>
						<SubmitButtonComponent
							@text="Save"
							@extraClass="save"
							@onTrigger={{this.save}}
							@submitInProgress={{this.submitInProgress}}
						/>
					</div>
				</div>
			</div>
		</div>
	</template>
}
